import React, { useRef } from "react";

import { dmnStorage } from "../../../../../utils/dmnStorage";
import { Button } from "../../../../Shared/Buttons/Button";
import { Input } from "../../../../ui/input";
import { Download, Minus, Plus } from "lucide-react";

export function StorageContent() {
  const dataToCache = useRef<any>();
  const idToCache = useRef<any>();
  const dataFromCache = useRef<any>();
  const idFromCache = useRef<any>();
  const idDeleteCache = useRef<any>();

  const addDataToCache = async function () {
    const data = dataToCache.current.value;
    const id = idToCache.current.value;
    await dmnStorage.add(id, data);
  };

  const getDataFromCache = async function () {
    const id = idFromCache.current.value;
    const result = await dmnStorage.get(id);
    dataFromCache.current.value = result;
  };

  const deleteDataFromCache = async function () {
    const id = idDeleteCache.current.value;
    await dmnStorage.delete(id);
  };

  return (
    <div className="StorageContent flex flex-col justify-center items-center h-full [&>*]:my-[10px]">
      <Input
        ref={idToCache}
        placeholder="Enter the id here..."
        style={{ width: "400px" }}
      />
      <Input
        ref={dataToCache}
        placeholder="Enter the data here..."
        style={{ width: "400px" }}
      />
      <Button
        type="primary"
        icon={<Plus className="size-5" />}
        onClick={addDataToCache}
      >
        Add data to cache
      </Button>
      <Input
        ref={idFromCache}
        placeholder="Enter the id here..."
        style={{ width: "400px" }}
      />
      <Button
        type="primary"
        icon={<Download className="size-5" />}
        onClick={getDataFromCache}
      >
        Get data from cache
      </Button>
      <Input ref={dataFromCache} disabled={true} style={{ width: "400px" }} />
      <Input
        ref={idDeleteCache}
        placeholder="Enter the id here..."
        style={{ width: "400px" }}
      />
      <Button
        type="primary"
        icon={<Minus className="size-5" />}
        onClick={deleteDataFromCache}
      >
        Delete data from cache
      </Button>
    </div>
  );
}
